
import { mapActions, mapGetters } from 'vuex';
import { GetOrganizationId, GetOrganizations, GetOrganizationById } from '@/constants/getters';
import { ChangeActiveOrganization } from '@/constants/actions';

export default {
  name: 'OrganizationSelect',

  computed: {
    ...mapGetters('authStore', {
      organizationId: GetOrganizationId,
      organizations: GetOrganizations,
      getOrganizationById: GetOrganizationById,
    }),
  },

  methods: {
    ...mapActions('authStore', {
      changeActiveOrganization: ChangeActiveOrganization,
    }),

    onOrganizationChange(value) {
      if (this.organizationId !== value) {
        const organization = this.getOrganizationById(value);

        if (organization) {
          this.changeActiveOrganization({ organizationId: organization.id, auth0Id: organization.auth0Id });
        }
      }
    },
  },
};
